import { withLocalePrefix } from 'shared/utils/translation';

const abbreviation = withLocalePrefix('gdpr.days_of_week.initials');
const name = withLocalePrefix('gdpr.days_of_week.names');

const getDaysOfWeekPickerOptions = () => [
  { label: abbreviation('sunday'), value: 0 },
  { label: abbreviation('monday'), value: 1 },
  { label: abbreviation('tuesday'), value: 2 },
  { label: abbreviation('wednesday'), value: 3 },
  { label: abbreviation('thursday'), value: 4 },
  { label: abbreviation('friday'), value: 5 },
  { label: abbreviation('saturday'), value: 6 },
];

const getDaysOfWeekDropdownOptions = () => [
  { label: name('sunday'), value: 0 },
  { label: name('monday'), value: 1 },
  { label: name('tuesday'), value: 2 },
  { label: name('wednesday'), value: 3 },
  { label: name('thursday'), value: 4 },
  { label: name('friday'), value: 5 },
  { label: name('saturday'), value: 6 },
];

export { getDaysOfWeekPickerOptions, getDaysOfWeekDropdownOptions };
